import { ManualRequestPagination } from "@lp/lp-ui";
import { CacheLookup } from "./app/cacheSlice";
import {
    CountryModel, ApplicationModel, RoleModel, UserListItemModel, UsersPagination
} from "./typings";

export function MapCountryModel(country: CountryModel): CacheLookup {
    const result: CacheLookup = {
        id: 0,
        key: country.countryAlpha3Code,
        label: country.name,
        description: country.name
    };
    return result;
}

export function MapApplicationModel(application: ApplicationModel): CacheLookup {
    const result: CacheLookup = {
        id: application.id,
        key: application.clientId,
        label: application.clientName,
        description: application.description
    };
    return result;
}

export function MapRoleModel(role: RoleModel): CacheLookup {
    const result: CacheLookup = {
        id: role.id,
        key: role.name,
        label: role.name,
        description: role.description
    };
    return result;
}

export function MapManualRequestPaginationToUsersPagination(organizationId: number, pagination: ManualRequestPagination<UserListItemModel>): UsersPagination {
    const result: UsersPagination = {
        ...pagination,
        organizationId: organizationId
    };
    return result;
}
